import React from "react";

const TenderingLandingPageContext = React.createContext({
  filter: undefined,
  setFilter: (filter) => {},
});

export default TenderingLandingPageContext;
